export const CONST_LABEL_LOCAL_GOV = "Municipality/City/District";
export const LABEL_NATURE_OF_BUSINESS = "nature_of_business";
export const LABEL_LST_THREHOLD = "lst_threhold";
export const LABEL_TURN_OVER_AMOUNT = "turn_over_amount";
